// external
import React, { Component } from "react";
import { PropTypes } from "prop-types";

// internal
import { customize } from "utils/hoc/Customize";

class CustomIconUI extends Component {
  constructor(props) {
    super(props);

    const section = props.hovered ? "icon_hover" : "icon";

    this.state = {
      iconStyles: props.getStyles(`${props.namespace}:${section}`),
    };
  }

  componentDidUpdate(prevProps) {
    const { hovered, namespace, getStyles } = this.props;

    if (prevProps.hovered !== hovered) {
      const section = hovered ? "icon_hover" : "icon";

      this.setState({
        iconStyles: getStyles(`${namespace}:${section}`),
      });
    }
  }

  onLinkOver = (e) => {
    if (this.props.disabled) return;

    let section = this.props.hovered ? "icon_hover" : "icon";
    if (e.type === "mouseenter" && !this.props.disabledHover)
      section = "icon_hover";

    this.setState({
      iconStyles: this.props.getStyles(`${this.props.namespace}:${section}`),
    });
  };

  getProps = () => {
    const notAllowedProps = [
      "getStyles",
      "isRouterLink",
      "namespace",
      "className",
      "disabledHover",
      "hovered",
    ];

    if (this.props.disabled) {
      notAllowedProps.push("onClick");
    }

    return Object.keys(this.props)
      .filter((key) => !notAllowedProps.includes(key))
      .reduce((obj, key) => {
        obj[key] = this.props[key];
        return obj;
      }, {});
  };

  render() {
    const props = this.getProps();

    return (
      <i
        style={this.state.iconStyles}
        className={`${this.props.className} ${this.props.disabled ? "disabled" : ""}`}
        onMouseEnter={this.onLinkOver}
        onMouseLeave={this.onLinkOver}
        {...props}
      >
        {this.props.children}
      </i>
    );
  }
}

CustomIconUI.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  getStyles: PropTypes.func.isRequired,
  namespace: PropTypes.string.isRequired,
  disabledHover: PropTypes.bool,
  hovered: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default customize()(CustomIconUI);
